import { Component, inject } from '@angular/core'
import { TranslocoPipe } from '@jsverse/transloco';
import { FormsModule } from '@angular/forms';
import { DateRange, extractDefaultStoreId, extractNumber, extractNumberArr, HxReportService, HxUiLabelPipe, InventoryManagementModel } from 'hx-services';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-inventory-management',
  templateUrl: './inventory-management-details.component.html',
  imports: [
    TranslocoPipe,
    FormsModule,
    HxUiLabelPipe,
    RouterLink,
  ],
  styleUrls: ['./inventory-management-details.component.css']
})
export class InventoryManagementDetailsComponent {
  params: {
    storeId?: number,
    date?: DateRange,
    categoryIds?: number[];
    productInfoId?: number;
  } = {};
  isLoading = {
    list: false,
  };
  im?: InventoryManagementModel;

  private readonly reportService = inject(HxReportService);
  private readonly router = inject(Router);
  private readonly aRoute = inject(ActivatedRoute);

  constructor() {
    this.aRoute.queryParamMap.pipe(takeUntilDestroyed()).subscribe(async paramMap => {
      this.params.date = {from: paramMap.get('dateFrom'), to: paramMap.get('dateTo')};
      this.params.categoryIds = extractNumberArr('categoryIds', paramMap, []);
      this.params.storeId = extractNumber('storeId', paramMap) ?? extractDefaultStoreId();
      this.params.productInfoId = extractNumber('productInfoId', paramMap);
      if (this.params.storeId && this.params.categoryIds) {
        this.load();
      }
    });
  }

  async load() {
    this.isLoading.list = true;
    try {
      const list = await this.reportService.getInventoryManagement({
        fromDate: this.params.date.from,
        toDate: this.params.date.to,
        storeId: this.params.storeId,
        categoryIds: this.params.categoryIds
      });
      this.im = list.filter(r => r.productInfoId === this.params.productInfoId)[0];
    } finally {
      this.isLoading.list = false;
    }
  }
}
